<mat-form-field class="dict-blog-authors">
  <mat-select
    [formControl]="control"
    [required]="required"
    [multiple]="multiple"
    [placeholder]="label"
    (selectionChange)="onSelectionChange($event)"
  >
    <mat-option>
      <ngx-mat-select-search
        [formControl]="authorFilterCtrl"
        placeholderLabel="Wyszukaj autora..."
        noEntriesFoundLabel="Nie znaleziono autora"
      >
      </ngx-mat-select-search>
    </mat-option>

    <mat-option
      *ngFor="let author of items"
      [value]="author.uuid"
    >
      {{ author.firstName }} {{ author.lastName }}
    </mat-option>
  </mat-select>

  <button
    *ngIf="(
      (control.value !== null
        && multiple
        && control.value?.hasOwnProperty('length')
        && control.value.length > 0
      )
      || (!multiple && control.value)
    )
    && !required
    && !control.disabled"
    matSuffix
    mat-icon-button
    type="button"
    aria-label="Wyczyść"
    (click)="clearValue(); $event.stopPropagation()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <mat-error *ngIf="control.hasError('required')">
    To pole jest wymagane
  </mat-error>

  <mat-error *ngIf="control.hasError('backendError')">
    {{ control.getError('backendError') }}
  </mat-error>
</mat-form-field>
